/**
 * Lib.Common: Form component declarations
 */


import ibCheckbox           from './ib-checkbox.vue';
import ibField              from './ib-field.vue';
import ibFieldDate          from './ib-field-date.vue';
import ibFieldNumeric       from './ib-field-numeric.vue';
import ibForm               from './ib-form.vue';
import ibFormArray          from './ib-form-array.vue';
import ibFormEntry          from './ib-form-entry.vue';
import ibFormObject         from './ib-form-object.vue';
import ibDropdown           from './ib-dropdown.vue';
import ibListbox            from './ib-listbox.vue';
import ibPickerDate         from './ib-picker-date.vue';
import ibPickerFile         from './ib-picker-file.vue';
import ibPickerTime         from './ib-picker-time.vue';
import ibRadio              from './ib-radio.vue';
import ibSlider             from './ib-slider.vue';
import ibToggle             from './ib-toggle.vue';


export default [
    ibCheckbox,
    ibField,
    ibFieldDate,
    ibFieldNumeric,
    ibForm,
    ibFormArray,
    ibFormEntry,
    ibFormObject,
    ibDropdown,
    ibListbox,
    ibPickerDate,
    ibPickerFile,
    ibPickerTime,
    ibRadio,
    ibSlider,
    ibToggle
];
